import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import RadioButton from '../common/RadioButton';
//Alerts
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { forgotPasswordEmail, forgotPasswordPhone } from '../../services/auth';

function Copyright(props) {
  return (
		<Typography
			variant='body2'
			color='text.secondary'
			align='center'
			{...props}
		>
			{'Copyright © '}
			<Link color='inherit' href='http://gsbsoirikapai.com/'>
				GSB Soirika
			</Link>{' '}
			{new Date().getFullYear()}
			{'.'}
		</Typography>
	);
}

const theme = createTheme();

export default function ForgotPassword() {
	const [email, setEmail] = React.useState('');
	const [emailError, setEmailError] = React.useState(false);

	const [phone, setPhone] = React.useState('');
	const [phoneError, setPhoneError] = React.useState(false);

  const [choice, setChoice] = React.useState("start");

  const emailValidation = () => {
    //regex email validation
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (emailRegex.test(email)) {
      setEmailError(false);

      return true;
    } else {
      setEmailError(true);
      return false;
    }
  };
  const phoneValidation = () => {
    //Phone number validation
    const phoneRegex = /^[0-9]{10}$/;
    if (phoneRegex.test(phone)) {
      setPhoneError(false);

      return true;
    } else {
      setPhoneError(true);
      return false;
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "phone":
        setPhone(value);
        break;
      case "choice":
        setChoice(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = async () => {
    try {
      if (choice === "Phone") {
        if (phoneValidation()) {
          let response = await forgotPasswordPhone(phone);
          if (response.errors) {
            toast.info("There was an issue. Please check the phone number.", {
              timeOut: 1000,
            });
            return;
          }
          setChoice("end");
        }
      } else if (choice === "Email") {
        if (emailValidation()) {
          let response = await forgotPasswordEmail(email);
          if (response.errors) {
            toast.info("There was an issue. Please check the email.", {
              timeOut: 1000,
            });
            return;
          }

          setChoice("end");
        }
      } else if (choice === "start") {
        toast.info("Please choose your account registration method", {
          timeOut: 1000,
        });
      }
    } catch (error) {
      console.error("there has been an error", {
        phone,
        email,
        choice,
        error,
      });
      toast.error(
        "There was an unexpected error. Please try after some time.",
        {
          timeOut: 1000,
        }
      );
    }
  };

  return (
    <>
      <div className="flex items-center justify-center h-screen p-4 bg-cover bg-[url(https://res.cloudinary.com/dxyulif7j/image/upload/v1728806107/forgot_pasword_bg_qhg99k.png)]">
        <CssBaseline />
        <ToastContainer />
        <div className="flex flex-col justify-center w-full max-w-md bg-white p-8 max-h-[90%] rounded-md shadow-2xl">
          <div className="flex flex-col items-center mb-2">
            <h1 className="text-2xl font-bold">FORGOT PASSWORD</h1>
          </div>
          <div className='text-center'>
              Please contact admin for resetting password
          </div>
          <div className='text-center'>
              <strong>Contact:</strong> +91 8296919479
          </div>
        </div>
      </div>
    </>
  );
}
